"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _withdrawActions = require("../../../redux/actions/withdrawActions");
var _HyphenWithdrawWorkflowComponent = _interopRequireDefault(require("./HyphenWithdrawWorkflowComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    template: state.withdraw.template,
    productId: state.withdraw.product,
    templateType: state.withdraw.templateType
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getBankInfoForm: function getBankInfoForm(productId, templateType) {
      return dispatch((0, _withdrawActions.fetchProductWithdrawTemplate)(productId, templateType, {
        UpdateBankData: true
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_HyphenWithdrawWorkflowComponent["default"]);